import { HiOutlineDocumentReport } from "react-icons/hi";
import { Button } from "@/components/ui/button/button";
import { PerformanceReportsModal } from "./performance-reports-modal";
import { usePerformanceReportsModal } from "./use-performance-reports-modal";

export const EmployeePerformanceReports = () => {
  const { onOpenChange } = usePerformanceReportsModal();

  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Performance Reports</h2>

        <HiOutlineDocumentReport className="w-3 h-3" />
      </div>
      <div
        className="justify-between flex items-center"
        onClick={() => {
          onOpenChange(true);
        }}
      >
        <Button variant="default" size="sm">
          View
        </Button>
      </div>

      <PerformanceReportsModal />
    </div>
  );
};
